import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';

const initialState = {
    tweets: null,
    distributions: [],
    error: null,
    loading: false
};

const getDistributionsStart = (state, action) => {
    return updateObject( state, { error: null, loading: true } );
}

const getDistributionsSuccess = (state, action) => {
    return updateObject( state, { 
        distributions: action.distributions, loading: false      
    });
}

const getDistributionsFail = (state, action) => {
    return updateObject( state, {
        error: action.error,
        loading: false
    });
}

const getDistributionsByDistStart = (state, action) => {
    return updateObject( state, { error: null, loading: true } );
}

const getDistributionsByDistSuccess = (state, action) => {
    return updateObject( state, { 
        distributions: action.distributions, loading: false      
    });
}

const getDistributionsByDistFail = (state, action) => {
    return updateObject( state, {
        error: action.error,
        loading: false
    });
}


const getTweetsSuccess = (state, action) => {
    return updateObject( state, { 
        tweets: action.tweets, loading: false      
    });
}

const setCurrentDistribution = (state, action) => {
    return updateObject( state, {
        currentDistribution: action.currentDistribution
    })
}

const reducer = ( state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_DISTRIBUTIONS_START: return getDistributionsStart(state, action);
        case actionTypes.GET_DISTRIBUTIONS_SUCCESS: return getDistributionsSuccess(state, action);
        case actionTypes.TWITTER_GET_TWEETS_SUCCESS: return getTweetsSuccess(state, action);
        case actionTypes.GET_DISTRIBUTIONS_FAIL: return getDistributionsFail(state, action);
        case actionTypes.SET_CURRENT_DISTRIBUTION: return setCurrentDistribution(state, action);
        case actionTypes.GET_DISTRIBUTION_BY_DIST_START: return getDistributionsByDistStart(state, action);
        case actionTypes.GET_DISTRIBUTION_BY_DIST_SUCCESS: return getDistributionsByDistSuccess(state, action);
        case actionTypes.GET_DISTRIBUTION_BY_DIST_FAIL: return getDistributionsByDistFail(state, action);
        default: 
            return state;
    }
}

export default reducer;
